import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./Component/Login";
import Register from "./Component/Register";
import Dashbaord from "./Component/Dashbaord";
import ForgotPassword from "./Component/ForgotPassword";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, logout, setLoading } from "./Reducer/authReducer";
import { jwtDecode } from "jwt-decode";
import Header from "./Component/Header";
import Authorization from "./Utils/authorization";
import Loader from "./Utils/Loader";
import Profile from "./Component/profile";

function App() {
  const dispatch = useDispatch();
  const { isAuth, loading } = useSelector((state) => state.Auth);
  const token = localStorage.getItem("jwt-token");

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
          localStorage.removeItem("jwt-token");
          dispatch(logout());
        } else {
          dispatch(login(decoded.user));
          Authorization(token);

        }
      } catch (error) {
        console.error("Error decoding token:", error);
        localStorage.removeItem("jwt-token");
        dispatch(logout());
      }
    }
    dispatch(setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <Router>
      {isAuth && <Header />}
      <Routes>
        <Route
          path="/login"
          element={!isAuth ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/register"
          element={!isAuth ? <Register /> : <Navigate to="/" />}
        />
        <Route
          path="/forgotpassword"
          element={!isAuth ? <ForgotPassword /> : <Navigate to="/" />}
        />

        <Route
          path="/"
          element={isAuth ? <Dashbaord /> : <Navigate to="/login" />}
        />
        <Route
          path="/profile"
          element={isAuth ? <Profile /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
